import { render, staticRenderFns } from "./ExcelUploader.vue?vue&type=template&id=6b2bb8a8&scoped=true"
import script from "./ExcelUploader.vue?vue&type=script&lang=js"
export * from "./ExcelUploader.vue?vue&type=script&lang=js"
import style0 from "./ExcelUploader.vue?vue&type=style&index=0&id=6b2bb8a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2bb8a8",
  null
  
)

export default component.exports